import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import { DRAWER_WIDTH, MAIN_CONTENT_TOP } from "../components/Constants";
import { getErrorString } from "../display/ErrorStrings";
import RejectedAccountItemsPage from "../containers/RejectedAccountItemsPage";
import PaidAccountItemsPage from "../containers/PaidAccountItemsPage";
import OutstandingAccountItemsPage from "../containers/OutstandingAccountItemsPage";
import ConsolidatedAccountItemsPage from "../containers/ConsolidatedAccountItemsPage";
import CdisbSummaryPage from "../containers/CdisbSummaryPage";
import CdisbDetailPage from "../containers/CdisbDetailPage";
import AchPaidAccountItemsPage from "../containers/AchPaidAccountItemsPage";
import AchExceptionAccountItemsPage from "../containers/AchExceptionAccountItemsPage";
import AccountReconciliationPage from "../containers/AccountReconciliationPage";

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },

  tableWrapper: {
    overflowX: "auto",
    overflowY: "auto",

    position: "fixed",
    top: `${MAIN_CONTENT_TOP + 20}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
    bottom: "0px",
  },
});

class AccountItemsConfigPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      reasons: [],
      options: [],
      transCodes: [],
      returnCodes: [],
      arpFormats: [],
      selectedOptionIndex: 0,
      selectedOption: {},
      reportChange: false,
      scrubTimeLeft: 0,
      crtTime: "",
    };
    this.onReportChange = this.onReportChange.bind(this);
  }

  onReportChange(e) {
    this.setState({ selectedOptionIndex: e.target.value });
    this.setState({ selectedOption: this.state.options[e.target.value] });
    this.setState({ reportChange: true });
  }

  componentDidUpdate() {
    if (this.state.reportChange) {
      this.setState({ reportChange: false });
    }
  }

  componentDidMount() {
    fetch("on_search_items_config", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        transit: this.props.accountObject.transit,
        account: this.props.accountObject.account,
        rangeStart: this.props.accountObject.rangeStart,
        rangeEnd: this.props.accountObject.rangeEnd,
        type: this.props.accountObject.accountType,
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
        } else {
          if (reply.options.length === 0) {
            this.setState({
              notifyString: "No permission. No report could be generated.",
            });
          } else {
            this.setState({ reasons: reply.reasons });
            this.setState({ transCodes: reply.transCodes });
            this.setState({ returnCodes: reply.returnCodes });
            this.setState({ arpFormats: reply.arpFormats });
            this.setState({ options: reply.options });
            this.setState({ selectedOption: reply.options[0] });
            this.setState({ selectedOptionIndex: reply.options[0].index });
            this.setState({ scrubTimeLeft: reply.scrubTimeLeft });
            var today = new Date();
            var time =
              ("0" + today.getHours()).slice(-2) +
              ":" +
              ("0" + today.getMinutes()).slice(-2);
            this.setState({ crtTime: time });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <div className={classes.tableWrapper}>
          {this.state.errorString.length > 0 && (
            <Typography color="error" variant="h6">
              &nbsp;&nbsp;{this.state.errorString}
            </Typography>
          )}
          {this.state.notifyString.length > 0 && (
            <Typography color="primary" variant="subheading">
              &nbsp;&nbsp;{this.state.notifyString}
            </Typography>
          )}
          {(this.state.selectedOption.id === "N" ||
            this.state.selectedOption.id === "C" ||
            this.state.selectedOption.id === "H" ||
            this.state.selectedOption.id === "D" ||
            this.state.selectedOption.id === "RETURNED") &&
            !this.state.reportChange && (
              <RejectedAccountItemsPage
                onReportChange={this.onReportChange}
                reasons={this.state.reasons}
                returnCodes={this.state.returnCodes}
                reports={this.state.options}
                option={this.state.selectedOption}
                secureToken={this.props.secureToken}
                history={this.props.history}
                uiExclusionsList={this.props.uiExclusionsList}
                viewOnly={this.props.viewOnly}
                accountObject={this.props.accountObject}
                accountsPerm={this.props.accountsPerm}
                scrubTimeLeft={this.state.scrubTimeLeft}
                crtTime={this.state.crtTime}
              />
            )}
          {(this.state.selectedOption.id === "P" ||
            this.state.selectedOption.id === "PNI") &&
            !this.state.reportChange && (
              <PaidAccountItemsPage
                onReportChange={this.onReportChange}
                reasons={this.state.reasons}
                reports={this.state.options}
                option={this.state.selectedOption}
                secureToken={this.props.secureToken}
                history={this.props.history}
                uiExclusionsList={this.props.uiExclusionsList}
                viewOnly={this.props.viewOnly}
                accountObject={this.props.accountObject}
                accountsPerm={this.props.accountsPerm}
              />
            )}
          {this.state.selectedOption.id === "O" && !this.state.reportChange && (
            <OutstandingAccountItemsPage
              onReportChange={this.onReportChange}
              reasons={this.state.reasons}
              reports={this.state.options}
              option={this.state.selectedOption}
              secureToken={this.props.secureToken}
              history={this.props.history}
              uiExclusionsList={this.props.uiExclusionsList}
              viewOnly={this.props.viewOnly}
              accountObject={this.props.accountObject}
              accountsPerm={this.props.accountsPerm}
            />
          )}
          {this.state.selectedOption.id === "K" && !this.state.reportChange && (
            <ConsolidatedAccountItemsPage
              onReportChange={this.onReportChange}
              reasons={this.state.reasons}
              reports={this.state.options}
              option={this.state.selectedOption}
              secureToken={this.props.secureToken}
              history={this.props.history}
              uiExclusionsList={this.props.uiExclusionsList}
              viewOnly={this.props.viewOnly}
              accountObject={this.props.accountObject}
              accountsPerm={this.props.accountsPerm}
            />
          )}
          {this.state.selectedOption.id === "cdisb_summary" &&
            !this.state.reportChange && (
              <CdisbSummaryPage
                onReportChange={this.onReportChange}
                reasons={this.state.reasons}
                reports={this.state.options}
                option={this.state.selectedOption}
                secureToken={this.props.secureToken}
                history={this.props.history}
                uiExclusionsList={this.props.uiExclusionsList}
                viewOnly={this.props.viewOnly}
                accountObject={this.props.accountObject}
                accountsPerm={this.props.accountsPerm}
              />
            )}
          {this.state.selectedOption.id === "cdisb_detail" &&
            !this.state.reportChange && (
              <CdisbDetailPage
                onReportChange={this.onReportChange}
                reasons={this.state.reasons}
                reports={this.state.options}
                option={this.state.selectedOption}
                secureToken={this.props.secureToken}
                history={this.props.history}
                uiExclusionsList={this.props.uiExclusionsList}
                viewOnly={this.props.viewOnly}
                accountObject={this.props.accountObject}
                accountsPerm={this.props.accountsPerm}
              />
            )}
          {this.state.selectedOption.id === "A" && !this.state.reportChange && (
            <AchPaidAccountItemsPage
              onReportChange={this.onReportChange}
              reports={this.state.options}
              option={this.state.selectedOption}
              secureToken={this.props.secureToken}
              history={this.props.history}
              uiExclusionsList={this.props.uiExclusionsList}
              viewOnly={this.props.viewOnly}
              accountObject={this.props.accountObject}
              accountsPerm={this.props.accountsPerm}
            />
          )}
          {this.state.selectedOption.id === "E" && !this.state.reportChange && (
            <AchExceptionAccountItemsPage
              onReportChange={this.onReportChange}
              reports={this.state.options}
              option={this.state.selectedOption}
              secureToken={this.props.secureToken}
              history={this.props.history}
              uiExclusionsList={this.props.uiExclusionsList}
              viewOnly={this.props.viewOnly}
              accountObject={this.props.accountObject}
              accountsPerm={this.props.accountsPerm}
              scrubTimeLeft={this.state.scrubTimeLeft}
              crtTime={this.state.crtTime}
            />
          )}
          {this.state.selectedOption.id === "R" && !this.state.reportChange && (
            <AccountReconciliationPage
              onReportChange={this.onReportChange}
              reports={this.state.options}
              option={this.state.selectedOption}
              secureToken={this.props.secureToken}
              history={this.props.history}
              uiExclusionsList={this.props.uiExclusionsList}
              viewOnly={this.props.viewOnly}
              accountObject={this.props.accountObject}
              accountsPerm={this.props.accountsPerm}
              transCodes={this.state.transCodes}
              arpFormats={this.state.arpFormats}
            />
          )}
        </div>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(AccountItemsConfigPage));
